{
  "meta": {
    "manager": {
      "name": "Dana Rivera",
      "first_name": "Dana"
    },
    "report": {
      "name": "Jordan Okafor",
      "first_name": "Jordan",
      "role": "Sr. Software Engineer",
      "tenure": "1 year 6 months"
    },
    "period": {
      "start": "2025-07-01",
      "end": "2026-03-06"
    },
    "generated": "2026-03-06",
    "meeting_count": 8,
    "work_summary_count": 9
  },
  "dashboard": [
    {
      "dimension": "Frequency Health",
      "icon": "📅",
      "status": "warn",
      "status_label": "Irregular",
      "detail": "Avg 27-day gaps, target ~14"
    },
    {
      "dimension": "Meeting Structure",
      "icon": "🏗️",
      "status": "good",
      "status_label": "Effective",
      "detail": "Rich topics, 5+ categories"
    },
    {
      "dimension": "Talk Ratio",
      "icon": "🎙️",
      "status": "good",
      "status_label": "Balanced",
      "detail": "Jordan drives most topics"
    },
    {
      "dimension": "Career Growth",
      "icon": "🚀",
      "status": "good",
      "status_label": "Thriving",
      "detail": "6 of 8 meetings, promotion active"
    },
    {
      "dimension": "Autonomy Delegation",
      "icon": "🎯",
      "status": "good",
      "status_label": "Well-Calibrated",
      "detail": "Report-driven decisions"
    },
    {
      "dimension": "Feedback Recognition",
      "icon": "⭐",
      "status": "good",
      "status_label": "Strong",
      "detail": "2 recognitions, regular praise"
    },
    {
      "dimension": "Blockers Support",
      "icon": "🔓",
      "status": "good",
      "status_label": "Clear Path",
      "detail": "0 open blockers"
    },
    {
      "dimension": "Expectations Tracker",
      "icon": "📋",
      "status": "good",
      "status_label": "On Track",
      "detail": "2 goals done, 1 at 70%"
    },
    {
      "dimension": "Personal Connection",
      "icon": "💛",
      "status": "warn",
      "status_label": "Adequate",
      "detail": "Light personal depth"
    },
    {
      "dimension": "Psychological Safety",
      "icon": "🛡️",
      "status": "good",
      "status_label": "Strong",
      "detail": "Concerns raised and acted on"
    },
    {
      "dimension": "Energy Alignment",
      "icon": "⚡",
      "status": "good",
      "status_label": "Well-Aligned",
      "detail": "High energy on key work"
    },
    {
      "dimension": "Workload Balance",
      "icon": "⚖️",
      "status": "good",
      "status_label": "Sustainable",
      "detail": "Steady pace, PTO taken"
    },
    {
      "dimension": "Decision Making",
      "icon": "⚙️",
      "status": "good",
      "status_label": "Decisive",
      "detail": "Decisions land and execute"
    },
    {
      "dimension": "Team Dynamics",
      "icon": "🤝",
      "status": "good",
      "status_label": "Well-Connected",
      "detail": "Cross-team + mentoring Leo"
    }
  ],
  "dimensions": [
    {
      "name": "Frequency Health",
      "icon": "📅",
      "status": "warn",
      "insights": [
        {
          "title": "Meeting cadence is inconsistent with significant gaps",
          "priority": "high",
          "body": "Across 8 meetings from July 2025 to January 2026, the average interval is approximately 27 days. The longest gap was 28 days (Aug 25 to Sep 22, partially explained by PTO) and there's a 43-day gap between Dec 8 and Jan 20. For a report on an active promotion track, biweekly meetings would be more appropriate to maintain momentum and provide timely support.",
          "evidence": "Meeting dates: Jul 14, Aug 4, Aug 25, Sep 22, Oct 13, Nov 10, Dec 8, Jan 20 — intervals of 21, 21, 28, 21, 28, 28, 43 days",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, I want to tighten up our 1-on-1 cadence — especially with the promotion cycle coming up. Can we commit to every two weeks? I think we've been averaging closer to monthly and I don't want important things to slip through the gaps.",
            "variant": "default"
          }
        },
        {
          "title": "No meeting data after January 2026 despite active work",
          "priority": "medium",
          "body": "The most recent meeting is January 20, 2026, but work summaries show active delivery through mid-February including the promotion packet submission and API gateway phase 2 work. This 45+ day gap without a 1-on-1 during a critical promotion window is a significant miss. Jordan submitted the promotion packet without a recent check-in to align on messaging.",
          "evidence": "Last meeting: Jan 20, 2026. Promotion packet submitted week of Feb 10. No meeting in between.",
          "action": {
            "label": "Manager Action",
            "text": "Schedule a 1-on-1 with Jordan this week. The promotion packet is submitted and the March calibration cycle is imminent — you need to be aligned on expectations, timeline, and any last-minute inputs needed.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Personal Connection",
      "icon": "💛",
      "status": "warn",
      "insights": [
        {
          "title": "Personal check-ins are surface-level and infrequent",
          "priority": "medium",
          "body": "Only 1 of 8 meetings (Aug 25) had an explicit personal/well-being topic — Jordan's upcoming PTO. The remaining meetings are entirely work-focused. While Jordan appears to be in a positive and energized state, the lack of personal depth means you'd likely miss early signals of stress, personal challenges, or shifting motivation. You know Jordan is performing well but may not know much about them as a person.",
          "evidence": "Aug 25 meeting: PTO discussion and 'workload is manageable' check-in. No other personal topics across 7 remaining meetings.",
          "action": {
            "label": "Open Next Meeting With",
            "text": "Jordan, before we dive in — how are you doing? Not work stuff, just you. The promotion packet is in, the projects are humming — I want to make sure you're feeling good about everything, not just delivering well.",
            "variant": "default"
          }
        },
        {
          "title": "Mood data is absent but sentiment signals are positive",
          "priority": "low",
          "body": "No formal mood tracking exists in the data, but Jordan's own notes consistently show positive sentiment: 'feeling confident,' 'excited but nervous,' 'relieved and proud,' 'mentoring is rewarding.' The trajectory is healthy. However, the absence of structured mood check-ins means subtle shifts could go unnoticed — especially as the promotion decision approaches, which can be an anxious period.",
          "evidence": "Jordan's notes: 'Feeling confident about Grafana dashboards' (Jul 14), 'Felt nervous presenting but the prep paid off' (Aug 25), 'Relieved and proud' (Nov 10), 'Mentoring Leo is rewarding' (Jan 20)",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, with the calibration cycle coming up, I know waiting for promotion decisions can be stressful even when things look good. How are you feeling about it? Is there anything weighing on you that we haven't talked about?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Career Growth",
      "icon": "🚀",
      "status": "good",
      "insights": [
        {
          "title": "Career development is deeply embedded in the relationship",
          "priority": "positive",
          "body": "Career growth appeared in 6 of 8 meetings, covering design review leadership, CKA certification, tech-lead aspirations, skip-level setup, cross-team project assignment, mentoring, and promotion packet preparation. This is an exceptionally well-structured growth trajectory. Dana has been proactive in creating stretch opportunities that build the promotion case — the API gateway project and OKR facilitation were deliberate development moves.",
          "evidence": "Jul 14: design review interest. Sep 22: tech-lead track discussion + skip-level arranged. Oct 13: cross-team lead assignment. Dec 8: promotion timeline confirmed. Jan 20: promotion packet in progress.",
          "action": {
            "label": "Keep Doing",
            "text": "Your career investment in Jordan is exemplary. You've created a clear progression — from design reviews to cross-team leadership to mentoring — that builds a compelling promotion case. Keep this cadence even after the promotion lands; the transition to tech lead will need just as much support.",
            "variant": "green"
          }
        },
        {
          "title": "Post-promotion growth plan needs to be defined",
          "priority": "medium",
          "body": "The current career conversation is heavily centered on the tech-lead promotion. Once that decision lands (March cycle), there's a risk of a 'now what?' vacuum. Jordan has shown appetite for continuous growth — leading design reviews, earning certifications, mentoring — so having a post-promotion development plan ready will maintain momentum and signal that promotion isn't the ceiling.",
          "evidence": "Dec 8 meeting: Q1 goals were all promotion-oriented (mentor Leo, lead OKR planning, prepare packet). No discussion of post-promotion trajectory.",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, regardless of how the March cycle goes, I want to start thinking about what your next 12 months look like. If you get the tech-lead title — which I expect — what does growth look like from there? What skills or experiences do you want that you don't have yet?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Autonomy Delegation",
      "icon": "🎯",
      "status": "good",
      "insights": [
        {
          "title": "Autonomy is well-calibrated and increasing appropriately",
          "priority": "positive",
          "body": "At ~16 months tenure, Jordan is firmly in the S3-S4 (Supporting/Delegating) range, and the meeting data confirms this is how Dana operates. Jordan proposes solutions (test coverage RFC), volunteers for ownership (postmortem follow-ups), drives technical decisions (Prometheus architecture), and leads cross-team coordination independently. Dana's role has correctly shifted to enabling and providing air cover rather than directing.",
          "evidence": "Jordan initiated: test coverage RFC, postmortem ownership request, mentoring Leo, pairing with Leo. Dana's role: approving exam fees, arranging skip-levels, nominating for opportunities, handling promotion logistics.",
          "action": {
            "label": "Keep Doing",
            "text": "You've successfully transitioned from coaching Jordan to delegating. The pattern of Jordan proposing and you enabling is exactly right for their level. As they become a tech lead, your role shifts further toward strategic alignment and organizational navigation.",
            "variant": "green"
          }
        },
        {
          "title": "Decision ownership is report-driven across all domains",
          "priority": "positive",
          "body": "Technical decisions (Prometheus architecture, gateway schema), problem identification (test coverage gaps, Leo's disengagement), and solution proposals (RFC, pairing sessions, runbook updates) are all consistently initiated by Jordan. Priority setting is shared — Dana proposes stretch opportunities and Jordan accepts and shapes them. This is the ideal pattern for a senior engineer moving toward tech lead.",
          "evidence": "Aug 4: Jordan noticed low test coverage and proposed the RFC. Nov 10: Jordan flagged Leo's disengagement and offered to help. Sep 22: Jordan volunteered to own postmortem follow-ups.",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, as you step into the tech-lead role, I want you to start making more calls without checking with me first — things like sprint scope changes, technical direction for the platform team, and process improvements. I trust your judgment. Let's agree on which decisions you should just make and inform me about, versus which ones we should discuss.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Feedback Recognition",
      "icon": "⭐",
      "status": "good",
      "insights": [
        {
          "title": "Recognition is specific, timely, and multi-channel",
          "priority": "positive",
          "body": "Dana has given two formal recognitions — one for the design doc (Engineering Excellence) and one for the API gateway leadership (Collaboration). Both are specific about what Jordan did and why it mattered. In-meeting recognition is also strong: praising ramp-up speed (Jul 14), relaying Raj's feedback (Aug 25), sharing Marcus's positive comments (Nov 10), and planning all-hands shoutouts (Nov 10, Dec 8). This is textbook recognition practice.",
          "evidence": "Two formal recognitions with specific descriptions. Aug 25: 'Dana highlighted positive feedback from staff engineer Raj.' Nov 10: 'Dana will announce CKA pass in team channel and add to all-hands shoutouts.'",
          "action": {
            "label": "Keep Doing",
            "text": "Your recognition game is strong — specific, timely, and you amplify it by sharing praise from others (Raj, Marcus). One suggestion: as Jordan moves into tech lead, start recognizing leadership behaviors specifically, not just technical outcomes. 'The way you facilitated that OKR session' matters as much as 'the migration shipped on time.'",
            "variant": "green"
          }
        },
        {
          "title": "Constructive feedback is largely absent from the data",
          "priority": "medium",
          "body": "Across 8 meetings, there is no recorded instance of constructive feedback from Dana to Jordan. While Jordan is clearly performing at a high level, even top performers benefit from growth-oriented feedback. The nervousness Jordan mentioned before the design review, and the 'bit nervous about cross-team coordination' comment, were opportunities to provide coaching feedback on areas to develop — not just reassurance.",
          "evidence": "Oct 13: Jordan noted being 'excited but a bit nervous about cross-team coordination.' Dana offered to be available for escalations but no coaching on specific skills to develop for cross-team work.",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, I realize I've been mostly giving you positive feedback — and you deserve it. But I also want to help you grow, especially as you step into a leadership role. One area I'd push you on: when you led the API gateway project, how did you handle disagreements or pushback? I want to help you sharpen your ability to navigate conflict across teams, because that's the hardest part of tech leadership.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Psychological Safety",
      "icon": "🛡️",
      "status": "good",
      "insights": [
        {
          "title": "Jordan demonstrates high vulnerability and candor",
          "priority": "positive",
          "body": "Jordan consistently shows vulnerability signals: admitting nervousness before the design review, expressing anxiety about cross-team coordination, flagging a teammate's disengagement, and volunteering to own postmortem follow-ups from an incident that happened on code they wrote. These behaviors indicate strong psychological safety — Jordan trusts that honesty won't be punished.",
          "evidence": "Aug 25: 'Felt nervous presenting but the prep paid off.' Oct 13: 'Excited but a bit nervous about cross-team coordination.' Nov 10: Proactively flagged Leo's disengagement. Sep 22: 'I want to own the follow-up items from the postmortem — good learning opportunity.'",
          "action": {
            "label": "Keep Doing",
            "text": "Jordan feels safe enough to admit nervousness, flag team issues, and take ownership of problems. This is the hallmark of strong psychological safety. Continue validating this behavior — every time Jordan raises something uncomfortable and you respond well, it reinforces the trust.",
            "variant": "green"
          }
        },
        {
          "title": "Raise-respond cycle is healthy — concerns get acted on",
          "priority": "positive",
          "body": "When Jordan raised the test coverage concern (Aug 4), Dana immediately empowered them to write the RFC. When Jordan flagged Leo's disengagement (Nov 10), Dana appreciated the initiative and supported the pairing approach. When Jordan expressed career aspirations (Sep 22), Dana set up the skip-level within weeks. This pattern — raise a concern, get support and action — is the engine of psychological safety.",
          "evidence": "Test coverage concern → RFC empowerment (Aug 4). Leo disengagement flag → supported pairing (Nov 10). Tech-lead interest → skip-level arranged (Sep 22). Postmortem ownership → approved (Sep 22).",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, I value that you bring things up directly — the test coverage issue, Leo's engagement, the career trajectory conversation. Is there anything you've been hesitant to raise? As you move into a leadership role, I want to make sure you feel comfortable pushing back on me too, not just flagging issues with the team.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Energy Alignment",
      "icon": "⚡",
      "status": "good",
      "insights": [
        {
          "title": "Jordan's energizers are well-mapped to current work",
          "priority": "positive",
          "body": "Jordan shows high energy around: system design and architecture (Prometheus design doc, gateway schema), cross-team leadership (API gateway project, 'hope we collaborate again'), mentoring ('mentoring Leo is rewarding'), and deep technical learning (K8s course, CKA cert, 'really enjoyed the networking deep-dive'). Current work assignments align remarkably well with these energizers — this is a person who is doing what they love.",
          "evidence": "Jordan's notes: 'Really enjoyed the networking deep-dive' (Aug 4). 'Want to do more of these' after design review (Aug 25). 'Mentoring Leo is rewarding. He asks great questions' (Jan 20). 'This was my biggest project yet... hope we collaborate again' (Dec 8).",
          "action": {
            "label": "Keep Doing",
            "text": "Jordan's energy map is clear: architecture, cross-team work, mentoring, and deep learning. You've been exceptionally good at creating opportunities that align with these. As a tech lead, ensure Jordan's role continues to include hands-on architecture work — don't let leadership responsibilities crowd out the technical depth that energizes them.",
            "variant": "green"
          }
        },
        {
          "title": "Potential drain areas are not yet visible",
          "priority": "low",
          "body": "There's no evidence of draining work in the current dataset — Jordan hasn't expressed frustration or disengagement with any work type. However, the tech-lead role will likely introduce new responsibilities (sprint planning facilitation, performance conversations, stakeholder management) that may not all be energizing. Proactively checking energy alignment as the role shifts will be important.",
          "evidence": null,
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, as you think about the tech-lead role, what parts excite you most and what parts do you think might be a grind? I want to set up the role in a way that plays to your strengths, not just dump every leadership responsibility on you.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Blockers Support",
      "icon": "🔓",
      "status": "good",
      "insights": [
        {
          "title": "No unresolved blockers — support is effective",
          "priority": "positive",
          "body": "Jordan's path has been remarkably clear of obstacles. The only potential blocker mentioned was the Payments team's conflicting December deadline (Nov 10), which was proactively identified and the project still shipped on time. Dana has been effective at removing friction before it becomes blocking: approving the CKA exam fee, arranging the skip-level, and offering escalation support for cross-team work.",
          "evidence": "Nov 10: Dana noted 'Need to help Jordan navigate the December deadline conflict proactively.' Dec 8: Project completed on time despite the risk.",
          "action": {
            "label": "Keep Doing",
            "text": "Your proactive support — approving resources, arranging connections, offering escalation cover — is allowing Jordan to operate without friction. As they take on more leadership, shift from 'removing blockers for Jordan' to 'teaching Jordan to remove blockers for their team.'",
            "variant": "green"
          }
        },
        {
          "title": "Promotion decision is the only current implicit blocker",
          "priority": "medium",
          "body": "The pending promotion decision in the March calibration cycle is the most significant open item. While not a traditional blocker, uncertainty about the outcome could affect Jordan's focus and morale. Dana should ensure Jordan has realistic expectations and knows the timeline, especially since they haven't had a meeting since January 20.",
          "evidence": "Dec 8: 'Skip-level with VP Eng Sarah confirmed positive trajectory for tech-lead promotion in Q1 2026.' Jan 20: Promotion packet in progress. Feb 10: Packet submitted. No meeting since.",
          "action": {
            "label": "Manager Action",
            "text": "Before the March calibration, have a pre-brief conversation with Jordan: 'The packet is in, Sarah is supportive, and here's the timeline for when we'll hear back. I'm confident, but I want you to know exactly what to expect so you're not guessing.'",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Expectations Tracker",
      "icon": "📋",
      "status": "good",
      "insights": [
        {
          "title": "Goal tracking is strong with regular check-ins",
          "priority": "positive",
          "body": "Two of three goals are completed (Prometheus migration at 100%, CKA at 100%), and the API gateway consolidation is at 70% with clear momentum. Goals were discussed in meetings regularly — the Aug 25 meeting had an explicit goal check-in, and goal progress was naturally embedded in most other meetings. The goal-to-meeting alignment is healthy.",
          "evidence": "Goal check-ins logged: Aug 4 (Prometheus 50%), Sep 22 (Prometheus 70%), Nov 10 (Prometheus 100%, CKA 100%), Jan 20 (API gateway 70%). Formal goal check-in on Aug 25.",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, two big goals are done and the gateway project is cruising. Let's formalize your Q1 goals beyond the promotion — what does success look like for you in the next 90 days, independent of the title change?",
            "variant": "default"
          }
        },
        {
          "title": "Q1 2026 goals discussed but not formalized as tracked goals",
          "priority": "low",
          "body": "In the Dec 8 meeting, three Q1 goals were discussed: mentor Leo, lead Q1 OKR planning, and prepare the promotion packet. These appear to be progressing (Leo shipped a feature, OKRs drafted, packet submitted) but they're not captured as formal tracked goals. Formalizing them would create clearer accountability and make the next review cycle easier to document.",
          "evidence": "Dec 8: 'Q1 2026 goals: (1) mentor Leo, (2) lead platform team's Q1 OKR planning, (3) prepare tech-lead promotion packet.' No corresponding goal artifacts found.",
          "action": {
            "label": "Manager Action",
            "text": "Create formal goal entries for Jordan's Q1 objectives so progress is tracked systematically. This also builds documentation for future review cycles and makes the mentoring and leadership work visible — not just the technical delivery.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Workload Balance",
      "icon": "⚖️",
      "status": "good",
      "insights": [
        {
          "title": "Pace is steady and sustainable with healthy recovery",
          "priority": "positive",
          "body": "Weekly output is consistent at 2-3 PRs per week across focused project areas. Jordan took PTO in September and returned smoothly. There's no sprint-crash pattern — output is steady rather than bursty. Context-switching is low, with weeks typically focused on 1-2 project areas. The addition of mentoring responsibilities hasn't visibly strained delivery.",
          "evidence": "Work summaries show 2-3 PRs/week consistently. PTO taken Sept 8-12. Post-PTO ramp-up was smooth (Sep 15 week). Typically 1-2 project areas per week.",
          "action": {
            "label": "Keep Doing",
            "text": "Jordan's workload is well-managed. You've done a good job sequencing projects rather than stacking them — the CKA prep ran alongside the gateway project but they were complementary, not competing. Watch the load as tech-lead responsibilities layer on top of IC work.",
            "variant": "green"
          }
        },
        {
          "title": "Tech-lead transition could create unsustainable dual load",
          "priority": "medium",
          "body": "Jordan is currently delivering at a high IC level (API gateway phase 2, rate limiting implementation) while also taking on leadership work (OKR facilitation, mentoring Leo, sprint planning). This dual load is common during the tech-lead transition but can become unsustainable. As the leadership surface area grows, something will need to come off the IC plate.",
          "evidence": "Feb 10 week: Leading sprint planning, mentoring Leo, implementing rate limiting, AND submitting promotion packet. Four distinct areas of work in one week.",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, you're carrying both a full IC load and growing leadership responsibilities. That's normal during a transition, but I don't want it to become permanent. As the tech-lead role formalizes, what IC work could we hand off or delegate to create space for the leadership work?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Decision Making",
      "icon": "⚙️",
      "status": "good",
      "insights": [
        {
          "title": "Decisions are made quickly and followed through consistently",
          "priority": "positive",
          "body": "Every significant discussion topic in the meeting data resulted in a clear decision that was subsequently executed. The test coverage RFC was proposed (Aug 4), drafted, submitted (Aug 25), and adopted. The skip-level was proposed (Sep 22) and happened. The cross-team project was assigned (Oct 13) and completed (Dec 8). There are zero looping topics in the dataset — this is exceptional decision velocity.",
          "evidence": "Test coverage: raised Aug 4 → RFC drafted by Aug 25 → adopted. Skip-level: proposed Sep 22 → completed before Dec 8. API gateway: assigned Oct 13 → completed Dec 8. CKA: approved Aug 4 → passed Nov 8.",
          "action": {
            "label": "Keep Doing",
            "text": "Your decision-making rhythm with Jordan is outstanding. Decisions are explicit, have owners, and get executed. This is a model you should replicate with your other reports.",
            "variant": "green"
          }
        },
        {
          "title": "Decisions are increasingly report-initiated",
          "priority": "positive",
          "body": "Early in the period, Dana proposed most decisions (present to the team, shadow design review). By the later meetings, Jordan is initiating decisions: volunteering for postmortem ownership, proposing to mentor Leo, drafting OKRs. This progression from manager-proposed to report-proposed decisions is exactly the right trajectory for someone moving into a tech-lead role.",
          "evidence": "Manager-initiated: 'present findings to platform team' (Jul 14), 'shadow design review' (Jul 14). Report-initiated: 'own postmortem follow-ups' (Sep 22), 'pair with Leo' (Nov 10), 'facilitated OKR brainstorm' (Jan 20).",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, I've noticed you're driving more decisions independently now, which is exactly where I want you. Going forward, I'd like you to start making technical decisions for the platform team and just loop me in afterward. What decisions do you think should still be joint versus ones you're comfortable owning outright?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Meeting Structure",
      "icon": "🏗️",
      "status": "good",
      "insights": [
        {
          "title": "Topic diversity is excellent with rich documentation",
          "priority": "positive",
          "body": "Meetings cover 6+ categories: project progress, career development, skill development, process improvement, team dynamics, well-being, incident review, and recognition. All 8 meetings have detailed summaries, highlights, and topic-level notes from both participants. This documentation quality is exceptional and makes pattern detection possible. Individual notes from both Dana and Jordan add valuable context.",
          "evidence": "All 8 meetings fully documented with summaries, categorized highlights, and topic-level discussion notes. Jordan and Dana both contribute individual notes.",
          "action": {
            "label": "Keep Doing",
            "text": "Your meeting documentation is a strength — it creates accountability, enables follow-up, and builds a record that supports the promotion case. Keep it up, and encourage Jordan to continue adding their individual notes.",
            "variant": "green"
          }
        },
        {
          "title": "Meetings could benefit from an explicit check-in ritual",
          "priority": "low",
          "body": "While meetings cover important topics thoroughly, they tend to jump straight into project and career topics. Only one meeting (Aug 25) included a well-being check-in. Adding a consistent 3-5 minute personal check-in at the start of each meeting would strengthen the personal connection dimension and catch mood shifts early — especially during the high-stakes promotion period.",
          "evidence": "Only Aug 25 meeting had an explicit well-being topic. Other meetings begin directly with project or career content.",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "I want to start each of our 1-on-1s with a quick human check-in before we get into the work stuff. Not a formality — I genuinely want to know how you're doing. Let's try it starting next meeting.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Talk Ratio",
      "icon": "🎙️",
      "status": "good",
      "insights": [
        {
          "title": "Jordan drives the majority of meeting content",
          "priority": "positive",
          "body": "Based on meeting structure analysis, Jordan is consistently the primary driver of discussion. Jordan proposes topics (test coverage, mentoring Leo, postmortem ownership), shares detailed updates, and contributes individual notes in most meetings. Dana's contributions are appropriately focused on enabling (approving resources, arranging connections, providing organizational context) rather than directing. The ratio appears to be approximately 60-65% Jordan / 35-40% Dana.",
          "evidence": "Jordan contributes individual notes in 6 of 8 meetings. Jordan initiates topics: test coverage RFC, postmortem ownership, Leo mentoring, career trajectory. Dana's contributions: feedback relay, resource approval, organizational navigation.",
          "action": {
            "label": "Keep Doing",
            "text": "Jordan owns the conversation in your 1-on-1s, which is the ideal state. As they transition to tech lead, consider pushing the ratio even further — ask Jordan to set the full agenda and come with recommendations rather than questions.",
            "variant": "green"
          }
        }
      ]
    },
    {
      "name": "Team Dynamics",
      "icon": "🤝",
      "status": "good",
      "insights": [
        {
          "title": "Jordan is building strong cross-team connections",
          "priority": "positive",
          "body": "Jordan's collaboration network has expanded significantly over the period. Key collaborators include Priya (on-call coverage, pairing on alert rules), Marcus (Payments team lead, API gateway project), Leo (mentee), and Raj (staff engineer, design review feedback). The cross-team API gateway project was particularly valuable for building relationships outside the platform team — exactly the kind of exposure needed for a tech-lead role.",
          "evidence": "Jul 14: plans to pair with Priya. Aug 25: Priya covering on-call. Nov 10: positive feedback from Marcus. Dec 8: 'Marcus and I worked well together — hope we collaborate again.' Jan 20: Leo shipped first solo feature under Jordan's mentoring.",
          "action": {
            "label": "Keep Doing",
            "text": "Jordan's network has grown from a single teammate (Priya) to cross-team relationships (Marcus) and a mentoring relationship (Leo). This breadth is exactly what a tech lead needs. Consider connecting Jordan with other team leads for peer-level relationships.",
            "variant": "green"
          }
        },
        {
          "title": "Jordan is proactively investing in team health",
          "priority": "positive",
          "body": "Jordan flagged Leo's disengagement in sprint ceremonies (Nov 10) and proactively offered to help — without being asked. This is a leadership behavior, not just an IC behavior. By January, Leo had shipped his first solo feature with Jordan's support. This kind of initiative — noticing team dynamics and acting on them — is the strongest signal that Jordan is ready for a formal leadership role.",
          "evidence": "Nov 10: 'Jordan flagged that Leo seems disengaged in sprint ceremonies. Offered to pair with Leo on a smaller task to build rapport.' Jan 20: 'Leo shipped his first solo feature after pairing sessions with Jordan.'",
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Jordan, what you did with Leo — noticing the disengagement and investing in him — is exactly the kind of leadership that makes a team better. How is Leo doing now? And are there other team dynamics you're noticing that we should talk about?",
            "variant": "default"
          }
        }
      ]
    }
  ],
  "agenda": {
    "next_meeting": [
      {
        "topic": "Promotion calibration pre-brief",
        "tags": ["career", "expectations"],
        "opener": "Jordan, the March calibration is coming up. Let me give you an honest update on where things stand, the timeline, and what to expect. I want you to go into this with zero ambiguity."
      },
      {
        "topic": "Bridge the meeting gap",
        "tags": ["frequency", "relationship"],
        "opener": "I realize we haven't had a proper 1-on-1 since January — that's too long, especially right now. I'm sorry about the gap. What's been on your mind that we should have been talking about?"
      },
      {
        "topic": "Personal check-in and well-being",
        "tags": ["personal", "well-being"],
        "opener": "Before we get into work stuff — how are you doing, really? The last few months have been intense between the gateway project, the promotion packet, and mentoring. How's your energy?"
      },
      {
        "topic": "Tech-lead transition planning",
        "tags": ["career", "autonomy"],
        "opener": "Whether the title comes through in March or April, I want us to plan the transition. What parts of the tech-lead role excite you most, and what parts feel uncertain? Let's design the role together."
      },
      {
        "topic": "IC-to-leadership workload balance",
        "tags": ["workload", "sustainability"],
        "opener": "You're carrying both deep IC work and leadership responsibilities. That's not sustainable forever. What IC work could we start handing off so you have room to lead without burning out?"
      },
      {
        "topic": "Constructive growth feedback",
        "tags": ["feedback", "growth"],
        "opener": "I want to give you some growth-oriented feedback — you've earned it. As you move into leadership, the hardest skill is navigating conflict and making unpopular decisions. How did you handle pushback during the gateway project? What would you do differently?"
      },
      {
        "topic": "API gateway phase 2 status",
        "tags": ["project", "expectations"],
        "opener": "How's the rate limiting and auth work progressing? Any risks to the Q1 timeline I should know about?"
      },
      {
        "topic": "Leo and team dynamics update",
        "tags": ["team", "mentoring"],
        "opener": "How's Leo doing? And now that you're more embedded as a team leader, what dynamics on the platform team are you noticing that I should be aware of?"
      }
    ],
    "phased_plan": [
      {
        "meeting": "Meeting 1 — Reconnect & Align",
        "theme": "Close the 6-week meeting gap, pre-brief the promotion cycle, and reset the personal connection",
        "topics": [
          "Acknowledge the meeting gap and recommit to biweekly cadence",
          "Personal check-in: how Jordan is doing holistically, not just professionally",
          "Promotion calibration pre-brief: timeline, expectations, what to prepare for",
          "Quick status on API gateway phase 2 and any blockers"
        ]
      },
      {
        "meeting": "Meeting 2 — Growth & Transition",
        "theme": "Plan the tech-lead transition and deliver constructive growth feedback",
        "topics": [
          "Post-promotion growth plan: what does the next 12 months look like beyond the title change?",
          "Constructive feedback on leadership skills: navigating conflict, making hard calls, delegating",
          "IC-to-leadership workload rebalancing: what to hand off, what to keep",
          "Formalize Q1 goals as tracked objectives"
        ]
      },
      {
        "meeting": "Meeting 3 — Team & Sustainability",
        "theme": "Expand from individual development to team-level leadership and long-term sustainability",
        "topics": [
          "Team dynamics deep-dive: Leo's progress, other team members, platform team health",
          "Decision ownership expansion: which decisions Jordan should own outright as tech lead",
          "Energy check: which parts of the new role are energizing vs. draining",
          "Set up peer connections with other team leads for tech-lead community building"
        ]
      }
    ]
  }
}
